<template>
  <div class="inner">
    <div class="header">
      <span class="back" @click="back">{{ $t("index.back") }}</span>
    </div>
    <div class="downloadcontent">
      <div class="left">
        <h1>{{ $t("index.softwarePackage") }}</h1>
        <a-skeleton active :loading="loading">
          <div class="vision">
            <h3 class="version-head">
              <span class="version-name">V{{ visionInfo.versionnumber }}</span
              ><a
                :href="visionInfo.fileurl"
                @click="download(visionInfo.fileurl, visionInfo.filename)"
                >{{ $t("index.download") }}</a
              >
            </h3>
            <h4 class="update-title">{{ $t("index.updateInfo") }}：</h4>
            <pre class="artticle">{{ visionInfo.remark }}</pre>
          </div>
        </a-skeleton>
      </div>
      <div class="right">
        <h1>{{ $t("index.EnvirPackage") }}</h1>
        <div class="vision">
          <h3 class="version-head">
            <span class="version-name">Microsoft Visual C++ v20200520 x86x64</span
            ><a
              href="https://cloud.bodor.com/Upload/Updata/CAM/Package/Microsoft Visual v20200520 x86 x64.exe"
              download="Microsoft Visual v20200520 x86 x64.exe"
              >{{ $t("index.download") }}</a
            >
          </h3>
          <h4 class="update-title">{{ $t("index.effect") }}：</h4>
          <ul>
            <li>{{ $t("index.effect1") }}</li>
          </ul>

          <h3 class="version-head">
            <span class="version-name">RuntimePack x86 x64 17.3.14</span
            ><a
              href="https://cloud.bodor.com/Upload/Updata/CAM/Package/RuntimePack x86 x64 17.3.14.exe"
              download="RuntimePack x86 x64 17.3.14.exe"
              >{{ $t("index.download") }}</a
            >
          </h3>
          <h4 class="update-title">{{ $t("index.effect") }}：</h4>
          <ul>
            <li>{{ $t("index.effect1") }}</li>
          </ul>

          <h3 class="version-head">
            <span class="version-name">NDP461-KB3102436-x86-x64-AllOS-ENU</span
            ><a
              href="https://cloud.bodor.com/Upload/Updata/CAM/Package/NDP461-KB3102436-x86-x64-AllOS-ENU.exe"
              download="NDP461-KB3102436-x86-x64-AllOS-ENU.exe"
              >{{ $t("index.download") }}</a
            >
          </h3>
          <h4 class="update-title">{{ $t("index.effect") }}：</h4>
          <ul>
            <li>{{ $t("index.effect1") }}</li>
          </ul>
        </div>

        <!--         <h1 style="margin-top: 30px">{{ $t("index.video") }}</h1>
        <div class="vision">
          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video1") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E8%BD%AF%E4%BB%B6%E7%99%BB%E5%BD%95%E4%B8%8E%E4%BD%BF%E7%94%A8%E6%B5%81%E7%A8%8B(1).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E8%BD%AF%E4%BB%B6%E7%99%BB%E5%BD%95%E4%B8%8E%E4%BD%BF%E7%94%A8%E6%B5%81%E7%A8%8B(1).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video2") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E5%88%9B%E5%BB%BA%E4%BB%BB%E5%8A%A1%E5%8F%8A%E5%AF%BC%E5%85%A5%20(2).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E5%88%9B%E5%BB%BA%E4%BB%BB%E5%8A%A1%E5%8F%8A%E5%AF%BC%E5%85%A5%20(2).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video3") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E4%B8%80%E9%94%AE%E8%AE%BE%E7%BD%AE%20(3).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E4%B8%80%E9%94%AE%E8%AE%BE%E7%BD%AE%20(3).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video4") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E8%87%AA%E5%8A%A8%E6%8E%92%E6%A0%B7%20(4).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E8%87%AA%E5%8A%A8%E6%8E%92%E6%A0%B7%20(4).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video5") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E6%89%8B%E5%8A%A8%E6%8E%92%E6%A0%B7%20(5).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E6%89%8B%E5%8A%A8%E6%8E%92%E6%A0%B7%20(5).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video6") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E8%87%AA%E5%8A%A8%E6%8E%92%E5%BA%8F%20(6).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E8%87%AA%E5%8A%A8%E6%8E%92%E5%BA%8F%20(6).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video7") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E6%89%8B%E5%B7%A5%E6%8E%92%E5%BA%8F%20(7).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E6%89%8B%E5%B7%A5%E6%8E%92%E5%BA%8F%20(7).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video8") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E6%8E%92%E6%A0%B7-%E5%B7%A5%E8%89%BA-%E6%8E%92%E5%BA%8F(8).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E6%8E%92%E6%A0%B7-%E5%B7%A5%E8%89%BA-%E6%8E%92%E5%BA%8F(8).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video9") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E7%BC%96%E8%BE%91%E5%85%B1%E8%BE%B9%E5%88%80%E8%B7%AF%20(9).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E7%BC%96%E8%BE%91%E5%85%B1%E8%BE%B9%E5%88%80%E8%B7%AF%20(9).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video10") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E4%BD%99%E6%96%99(10).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E4%BD%99%E6%96%99(10).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video11") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E9%AA%A8%E6%9E%B6%E5%88%87%E7%A2%8E(11).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E9%AA%A8%E6%9E%B6%E5%88%87%E7%A2%8E(11).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video12") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E6%8A%A5%E5%91%8A%E5%8D%95%20(12).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E6%8A%A5%E5%91%8A%E5%8D%95%20(12).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video13") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E5%AF%BC%E5%87%BANC(13).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E5%AF%BC%E5%87%BANC(13).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video14") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E8%87%AA%E5%8A%A8%E5%BE%AE%E8%BF%9E%20(14).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E8%87%AA%E5%8A%A8%E5%BE%AE%E8%BF%9E%20(14).mp4"
            />
          </video>

          <h3 class="version-head">
            <span class="version-name">{{ $t("index.video15") }}</span>
          </h3>
          <video
            width="540"
            height="300"
            preload="none"
            src="https://cloud.bodor.com/Portal/assets/videos/%E5%A4%96%E9%83%A8%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%20(15).mp4"
            controls
          >
            <source
              src="https://cloud.bodor.com/Portal/assets/videos/%E5%A4%96%E9%83%A8%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%20(15).mp4"
            />
          </video>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import { ref } from "vue";
import axios from "axios";
import { message } from "ant-design-vue";

let router = useRouter();
let route = useRoute();

const loading = ref(false);

const isVisitor = ref(route.params.isVisitor);
if (!isVisitor.value) {
  isVisitor.value = localStorage.getItem("isVisitor");
}

const back = () => {
  history.back();
  /*   if (window.history.length > 1) {
    history.back();
    console.log(history);
  } else {
    router.push(`/visitor/software`);
  } */
  /*   if (isVisitor.value == "false") {
    router.push(`/index/software`);
  } else {
    router.push(`/visitor/software`);
  } */
};

const visionInfo = ref({});

loading.value = true;
axios
  .post("api/Cam/GetCamAssistant", {
    ProductType: "1",
  })
  .then((response) => {
    if (response.data.ReturnData.length > 0) {
      visionInfo.value = response.data.ReturnData[0];
      visionInfo.value.fileurl = "https://apicloud.bodor.com" + visionInfo.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading.value = false;
  });

const download = (url, name) => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = url;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", name);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  if (isVisitor.value == "false") {
    axios
      .post("/api/Cam/InsertDownload", {
        CamEdition: visionInfo.value.id,
      })
      .then((response) => {
        if (response.data.code != 200) {
          message.error(response.data.info);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    axios
      .post("/api/Cam/AllowInsertDownload", {
        CamEdition: visionInfo.value.id,
      })
      .then((response) => {
        if (response.data.code != 200) {
          message.error(response.data.info);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
};
</script>

<style scoped>
.inner {
  width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  color: black;
  position: relative;
  padding: 70px 0px;
}
.downloadcontent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.left {
  width: 45%;
}
.right {
  width: 45%;
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
a {
  color: #0099ff;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
  flex-direction: column;
}
.vision {
  margin: 1em 0 0;
  border-bottom: 1px solid #eee;
}
.version-head {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.version-name {
  margin-right: 20px;
}
.update-title {
  margin: 0 0 10px;
  font-weight: 400;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 28px;
  margin-bottom: 20px;
}
li {
  display: list-item;
  text-align: -webkit-match-parent;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.artticle {
  width: 100%;
  border: none;
  padding: 0 8px;
  background-color: white;
  margin-bottom: 0px;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-family: Menlo, Monaco, Consolas, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>
